import React, { Component, Fragment } from 'react';
import { Tag, Table, Empty, Button, Popconfirm, Alert } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';

@inject('store')
@observer
export class Position extends Component {
    render() {
        const { position, exchangePosition } = this.props.store.makoBotStore;

        if (!position || !exchangePosition)
            return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No position open" />;
        const timezone = this.props.store.userStore.currentUser.timezone;
        const exitOrders = position.exit_orders.filter(l => l.status === 'open');
        const firstExit = exitOrders[0];
        return (
            <Fragment>
                {exchangePosition.leverage < 49 ? (
                    <Alert
                        message="Ensure leverage has been set to cross "
                        type="warning"
                        showIcon
                    />
                ) : null}
                <Table
                    bordered
                    rowKey={position => position.symbol}
                    dataSource={[position]}
                    pagination={false}
                    scroll={{ x: 1000 }}
                    columns={[
                        {
                            title: 'Side',
                            dataIndex: 'side',
                            key: 'status',
                            align: 'center',
                            render: text =>
                                text === 'BUY' ? (
                                    <i className={`fal fa-arrow-up success`} />
                                ) : position.side === 'SELL' ? (
                                    <i className={`fal fa-arrow-down error`} />
                                ) : null
                        },
                        {
                            title: 'Symbol',
                            dataIndex: 'symbol',
                            key: 'symbol',
                            align: 'center'
                        },
                        {
                            title: 'Layers',
                            dataIndex: 'layers',
                            key: 'layers',
                            align: 'center',
                            render: (text, o) => {
                                return (
                                    <span>
                                        {o.entry_orders_open}/{o.layers.length}
                                    </span>
                                );
                            }
                        },
                        {
                            title: 'Qty',
                            dataIndex: 'entry_orders_filled',
                            key: 'entry_orders_filled',
                            align: 'center'
                        },
                        {
                            title: 'Margin',
                            dataIndex: 'position_margin',
                            key: 'position_margin',
                            align: 'center',
                            render: (text, o) => {
                                return (
                                    <span>
                                        {exchangePosition.position_margin} <br />
                                        {exchangePosition.position_margin_usd.toFixed(2)} USD
                                    </span>
                                );
                            }
                        },
                        {
                            title: 'Price',
                            dataIndex: 'avg_entry',
                            key: 'avg_entry',
                            align: 'center',
                            render: (text, o) => {
                                return <span>{text.toFixed(4)}</span>;
                            }
                        },
                        {
                            title: 'Liq. Price',
                            dataIndex: 'liq_price',
                            key: 'liq_price',
                            render: (text, o) => {
                                return (
                                    <span style={{ color: '#f4b344' }}>
                                        {exchangePosition.liq_price.toFixed(4)}
                                    </span>
                                );
                            }
                        },
                        {
                            title: 'Exit Price',
                            dataIndex: 'exit_price',
                            key: 'exit_price',
                            align: 'center',
                            render: (text, o) => {
                                return <span>{(firstExit && firstExit.price) || 'N/A'}</span>;
                            }
                        },
                        {
                            title: 'Stop Price',
                            dataIndex: 'stop_loss',
                            key: 'stop_loss',
                            align: 'center',
                            render: (text, o) => {
                                return (
                                    <span>
                                        {(o.stop_loss &&
                                            o.stop_loss.stop_px &&
                                            o.stop_loss.stop_px.toFixed(4)) ||
                                            'N/A'}
                                    </span>
                                );
                            }
                        },
                        {
                            title: 'Fees',
                            dataIndex: 'fees',
                            key: 'fees',
                            align: 'center',
                            render: (text, o) => {
                                return (
                                    <span className={o.fees <= 0 ? 'success' : 'error'}>
                                        {(o.fees * -1).toFixed(8)} <br />
                                        {(o.fees_usd * -1).toFixed(2)} USD
                                    </span>
                                );
                            }
                        },
                        {
                            title: 'Unrealised P&L',
                            dataIndex: 'pnl',
                            key: 'pnl',
                            align: 'center',
                            render: (text, o) => {
                                return (
                                    <span className={o.pnl < 0 ? 'error' : 'success'}>
                                        <span style={{ display: 'inline-block', width: 95 }}>
                                            {o.pnl.toFixed(8)} <br />
                                            {o.pnl_usd.toFixed(2)} USD
                                        </span>
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: 70,
                                                verticalAlign: 'top',
                                                paddingTop: 10
                                            }}
                                        >
                                            (
                                            {o.entry_orders_filled > 0
                                                ? (
                                                      (Math.abs(exchangePosition.unrealised_pnl) /
                                                          exchangePosition.position_margin) *
                                                          100 || 0
                                                  ).toFixed(2)
                                                : 0}
                                            %)
                                        </span>
                                    </span>
                                );
                            }
                        },
                        {
                            title: 'Realised P&L',
                            dataIndex: 'rpnl',
                            key: 'rpnl',
                            align: 'center',
                            render: (text, o) => {
                                return (
                                    <span
                                        className={
                                            exchangePosition.realised_pnl < 0 ? 'error' : 'success'
                                        }
                                    >
                                        {exchangePosition.realised_pnl.toFixed(8)} <br />
                                        {exchangePosition.realised_pnl_usd.toFixed(2)} USD
                                    </span>
                                );
                            }
                        }
                    ]}
                />
                <Table
                    bordered
                    rowKey={layer => (layer.order && layer.order.id) || layer.price}
                    dataSource={position.layers}
                    style={{ marginTop: 15 }}
                    pagination={false}
                    scroll={{ x: 1000 }}
                    columns={[
                        {
                            title: 'Status',
                            align: 'center',
                            dataIndex: 'status',
                            key: 'status',
                            render: text => (
                                <Tag
                                    color={`${
                                        text === 'FILLED'
                                            ? '#29c0b1'
                                            : text === 'CANCELED'
                                            ? '#ff3366'
                                            : '#2c50ed'
                                    }`}
                                >
                                    {text}
                                </Tag>
                            )
                        },
                        {
                            title: 'Price',
                            dataIndex: 'price',
                            key: 'price',
                            align: 'center'
                        },
                        {
                            title: 'Qty',
                            dataIndex: 'qty',
                            key: 'qty',
                            align: 'center'
                        },
                        {
                            title: 'Fee',
                            dataIndex: 'Fee',
                            key: 'fee',
                            align: 'center',
                            render(text, o) {
                                return o.order && o.order.info.cum_exec_fee ? (
                                    <span
                                        className={
                                            o.order.info.cum_exec_fee <= 0 ? 'success' : 'error'
                                        }
                                    >
                                        {(o.order.info.cum_exec_fee * -1).toFixed(8)}
                                    </span>
                                ) : (
                                    'N/A'
                                );
                            }
                        },
                        {
                            title: 'Filled at',
                            dataIndex: 'filled_at',
                            key: 'filled_at',
                            align: 'center',
                            render(text, o) {
                                return o.order && o.order.lastTradeTimestamp
                                    ? moment(o.order.lastTradeTimestamp)
                                          .tz(timezone)
                                          .format('DD/MM/YYYY hh:mm a')
                                    : null;
                            }
                        },
                        {
                            title: 'Description',
                            dataIndex: 'description',
                            key: 'description',
                            align: 'left'
                        },
                        {
                            title: '',
                            dataIndex: 'actions',
                            key: 'actions',
                            align: 'center',
                            render: (text, o) => {
                                if (o.status === 'PLACED') {
                                    return (
                                        <Popconfirm
                                            placement="top"
                                            title={'Cancel Layer'}
                                            onConfirm={() => {
                                                this.props.store.makoBotStore.cancelEntryLayer(
                                                    o.order.id
                                                );
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button type="danger">Cancel</Button>
                                        </Popconfirm>
                                    );
                                }
                                return null;
                            }
                        }
                    ]}
                />
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/Position.js